
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Eng. João Paulo Scardelato Severino</h3>
            <p className="text-slate-300 mb-4">
              Perito Judicial • Assistente Técnico
            </p>
            <p className="text-slate-300">
              Perícias com clareza e rigor pericial desde 2012 — atuação no TJ/SP e TRT‑15.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <div className="space-y-2">
              <button
                onClick={() => scrollToSection('inicio')}
                className="block text-slate-300 hover:text-white cursor-pointer"
              >
                Início
              </button>
              <button
                onClick={() => scrollToSection('sobre')}
                className="block text-slate-300 hover:text-white cursor-pointer"
              >
                Sobre
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className="block text-slate-300 hover:text-white cursor-pointer"
              >
                Serviços
              </button>
              <button
                onClick={() => scrollToSection('como-trabalho')}
                className="block text-slate-300 hover:text-white cursor-pointer"
              >
                Como Trabalho
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="block text-slate-300 hover:text-white cursor-pointer"
              >
                Contato
              </button>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <div className="space-y-2 text-slate-300">
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line"></i>
                </div>
                (17) 99734‑6470
              </p>
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line"></i>
                </div>
                peritojpss@gmail.com
              </p>
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-map-pin-line"></i>
                </div>
                Alameda Sabará, 54 — Bebedouro/SP
              </p>
              <a
                href="https://www.linkedin.com/in/joaopauloscardelatoseverino"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:text-white cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-linkedin-fill"></i>
                </div>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2024 Eng. João Paulo Scardelato Severino. Todos os direitos reservados.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-white text-sm cursor-pointer mt-2 sm:mt-0"
          >
            Made with Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
